import { ButtonProps as ChakraButtonProps, Button as ChakraButton } from '@chakra-ui/react/button'
import { Spinner } from '@chakra-ui/react/spinner'
import { AbsoluteCenter } from '@chakra-ui/react'
import { Span } from '@chakra-ui/react'
import * as React from 'react'
import { ButtonAppearance } from '../atoms/Button/types'

export type ButtonProps = ChakraButtonProps & {
  loading?: boolean
  loadingText?: string
  buttonAppearance: ButtonAppearance
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  props: ButtonProps,
  ref: React.Ref<HTMLButtonElement>,
) {
  const { loading, disabled, loadingText, children, ...rest } = props
  return (
    <ChakraButton disabled={loading || disabled} ref={ref} {...rest}>
      {loading && !loadingText ? (
        <>
          <AbsoluteCenter display="inline-flex">
            <Spinner size="inherit" color="inherit" />
          </AbsoluteCenter>
          <Span opacity={0}>{children}</Span>
        </>
      ) : loading && loadingText ? (
        <>
          <Spinner size="inherit" color="inherit" />
          {loadingText}
        </>
      ) : (
        children
      )}
    </ChakraButton>
  )
})
